import { useQueryClient } from '@tanstack/react-query';

export const useOptionalQueryClient = () => {
    try {
        return useQueryClient();
    } catch (error) {
        return null;
    }
};
